import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccessLandControl = _resolveComponent("AccessLandControl")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accessLands, (landAccess, key) => {
      return (_openBlock(), _createElementBlock("div", null, [
        (_openBlock(), _createBlock(_component_AccessLandControl, {
          value: landAccess,
          key: key,
          "land-types": _ctx.landTypes,
          validate: _ctx.validate,
          onInput: ($event: any) => (_ctx.accessLands[key] = $event),
          onRemove: ($event: any) => (_ctx.removeAccessLand(key))
        }, null, 8, ["value", "land-types", "validate", "onInput", "onRemove"]))
      ]))
    }), 256)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "btn btn-outline-primary w-auto",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addAccessLand()))
      }, " Přidat přístup na pozemek ")
    ])
  ]))
}